/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-19",
    versionChannel: "nightly",
    buildDate: "2023-10-19T00:23:16.593Z",
    commitHash: "fd4d6921d851e788b1386affae1498e46cda939c",
};
